(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/radio-group.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/radio-group.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (radio_group)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }

  function RadioGroup(_ref) {
    let className = _ref.className,
      gap = _ref.gap,
      inline = _ref.inline,
      size = _ref.size,
      multipleLines = _ref.multipleLines,
      minWidth = _ref.minWidth,
      id = _ref.id,
      thin = _ref.thin,
      children = _ref.children;
    const classes = ['form-toggle-group'];
    if (className) {
      classes.push(className);
    }
    if (gap) {
      classes.push('form-toggle-group-gap');
    }
    if (inline) {
      classes.push('form-toggle-inline');
    }
    if (size) {
      classes.push("form-toggle-group-".concat(size));
    }
    if (multipleLines) {
      classes.push('form-toggle-multiple-lines');
    }
    if (thin) {
      classes.push('form-toggle-thin');
    }
    return React.createElement("div", {
      className: classes.join(' '),
      id: id,
      style: _objectSpread(_objectSpread({}, minWidth && {
        'min-width': minWidth
      }), gap && {
        '--gap': gap
      }),
      type: "radiogroup"
    }, children);
  }
  RadioGroup.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "RadioGroup",
    "props": {
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "gap": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        },
        "required": false
      },
      "id": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "inline": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "minWidth": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "multipleLines": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "size": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        },
        "required": false
      },
      "thin": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      }
    }
  };
  const radio_group = RadioGroup;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).RadioGroup = __webpack_exports__["default"];
})();

 })(window);